/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import RouteChangeTracking from '@Services/RouteChangeTracking';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import { confirmationFromEmailLink as confirmationFromEmailLinkAction } from './RegisterConfirmationActions';

import './RegisterConfirmation.custom.scss';

export function RegisterConfirmationContainer({ regId, shibbolethToken, confirmationFromEmailLink }) {
  useEffect(() => {
    confirmationFromEmailLink({ regId, shibbolethToken });
  }, [regId]);

  useEffect(() => {
    RouteChangeTracking.trackOnRouteChangeSuccess();
  }, []);

  return (
    <>
      <div id="hexagon-visuals" />
      <SimpleSpinner className="register-confirmation__spinner" />
    </>
  );
}

RegisterConfirmationContainer.defaultProps = {
  confirmationFromEmailLink: () => {},
};

RegisterConfirmationContainer.propTypes = {
  regId: PropTypes.string,
  shibbolethToken: PropTypes.string,
  confirmationFromEmailLink: PropTypes.func,
};

const mapDispatchToProps = {
  confirmationFromEmailLink: confirmationFromEmailLinkAction,
};

export default connect(null, mapDispatchToProps)(withCombinedRouteParams(RegisterConfirmationContainer));
